import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showEditIconPipe'
})
export class ShowEditIconPipePipe implements PipeTransform {

  transform(value: any,isShowSuperEdit?:any,isShowEdit?:any): boolean {
    if (isShowSuperEdit)
            return true;
        else
            return !value.approved_Tag && !value.isShowSupersedeIcon && !value.is_WF_Started && isShowEdit
   
  }

}
